import React, { useState } from "react";
import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export default function DatePicker({ value, onChange, placeholder = "Pick a date", testId }) {
  const [open, setOpen] = useState(false);
  // value: YYYY-MM-DD string
  const date = value ? new Date(value + "T00:00:00") : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId}
          className="w-full text-left border border-[var(--line)] rounded-lg px-3 py-2.5 bg-white flex items-center justify-between gap-2 hover:border-zinc-400 transition-colors">
          <span className={value ? "text-zinc-900" : "text-zinc-400"}>
            {value ? format(date, "PPP") : placeholder}
          </span>
          <CalendarIcon size={16} className="text-zinc-400" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-auto bg-white" align="start">
        <DayPicker
          mode="single"
          selected={date}
          onSelect={(d) => {
            if (d) onChange(format(d, "yyyy-MM-dd"));
            setOpen(false);
          }}
          showOutsideDays
          className="p-3"
        />
      </PopoverContent>
    </Popover>
  );
}
